import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
var ArrowContainer = styled.div.withConfig({
  displayName: "Arrow__ArrowContainer",
  componentId: "vapor__sc-25fwog-0"
})(["position:absolute;background-repeat:no-repeat;&[data-hide]{visibility:hidden;}&[data-position*='top']{width:27px;height:7px;left:50%;transform:translateX(-50%);top:100%;}&[data-position*='bottom']{width:27px;height:7px;left:50%;transform:translateX(-50%);bottom:100%;}&[data-position='bottom-start'],&[data-position='top-start']{left:0;transform:none;}&[data-position='bottom-end'],&[data-position='top-end']{left:unset;right:0;transform:none;}&[data-position*='right']{height:27px;width:7px;right:100%;top:50%;transform:translateY(-50%);}&[data-position*='left']{height:27px;width:7px;left:calc(100% - 1px);top:50%;transform:translateY(-50%);}&[data-position='right-start'],&[data-position='left-start']{top:0;transform:none;}&[data-position='right-end'],&[data-position='left-end']{top:unset;bottom:0;transform:none;}svg{float:left;}"]);
export var Arrow = React.forwardRef(function (_ref, ref) {
  var position = _ref.position,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, ["position", "className"]);

  var renderArrow = function renderArrow() {
    switch (position) {
      case 'top':
      case 'top-start':
      case 'top-end':
        return /*#__PURE__*/React.createElement(ArrowDown, null);

      case 'bottom':
      case 'bottom-start':
      case 'bottom-end':
        return /*#__PURE__*/React.createElement(ArrowUp, null);

      case 'left':
      case 'left-start':
      case 'left-end':
        return /*#__PURE__*/React.createElement(ArrowRight, null);

      case 'right':
      case 'right-start':
      case 'right-end':
        return /*#__PURE__*/React.createElement(ArrowLeft, null);

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(ArrowContainer, _extends({
    className: className,
    "data-position": position,
    ref: ref,
    "data-popper-arrow": true
  }, other), renderArrow());
});

function ArrowUp() {
  return /*#__PURE__*/React.createElement("svg", {
    width: 26,
    height: 7,
    viewBox: "0 0 26 7",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fio-arrow-up-filter)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.453.91l-4.3 4.014A4 4 0 013.423 6h18.154a4 4 0 01-2.73-1.076L14.547.91a3 3 0 00-4.094 0z",
    fill: "#2C2D3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.135 1.974l-4.232 3.95A4 4 0 014.173 7h16.653a4 4 0 01-2.729-1.076l-4.233-3.95a2 2 0 00-2.729 0z",
    fill: "#060609"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fio-arrow-up-filter"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 25.5 0)",
    fill: "#fff",
    d: "M0 0h25.5v7H0z"
  }))));
}

function ArrowDown() {
  return /*#__PURE__*/React.createElement("svg", {
    width: 27,
    height: 7,
    viewBox: "0 0 27 7",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fio-arrow-down-filter)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.234 6.089l-4.3-4.014A4 4 0 004.204 1h18.154a4 4 0 00-2.73 1.075l-4.3 4.014a3 3 0 01-4.094 0z",
    fill: "#2C2D3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.916 5.026L7.48.885A3.293 3.293 0 005.233 0H21.33c-.834 0-1.637.316-2.247.885l-4.436 4.14a2 2 0 01-2.73 0z",
    fill: "#060609"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fio-arrow-down-filter"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 26.281 7)",
    fill: "#fff",
    d: "M26.281 7h25.5v7h-25.5z"
  }))));
}

function ArrowLeft() {
  return /*#__PURE__*/React.createElement("svg", {
    width: 8,
    height: 26,
    viewBox: "0 0 8 26",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fio-arrow-left-filter)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.41 15.046l4.014 4.3a4 4 0 011.076 2.73V3.923a4 4 0 01-1.076 2.73l-4.014 4.3a3 3 0 000 4.094z",
    fill: "#2C2D3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.474 14.364l3.95 4.233a4 4 0 011.076 2.73V4.672a4 4 0 01-1.076 2.73l-3.95 4.232a2 2 0 000 2.73z",
    fill: "#060609"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fio-arrow-left-filter"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0 1 1 0 .5 0)",
    fill: "#fff",
    d: "M0 0h25.5v7H0z"
  }))));
}

function ArrowRight() {
  return /*#__PURE__*/React.createElement("svg", {
    width: 8,
    height: 26,
    viewBox: "0 0 8 26",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fio-arrow-right-filter)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59 15.046l-4.014 4.3a4 4 0 00-1.076 2.73V3.923a4 4 0 001.076 2.73l4.014 4.3a3 3 0 010 4.094z",
    fill: "#2C2D3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.526 14.364l-3.95 4.233A4 4 0 00.5 21.327V4.672a4 4 0 001.076 2.73l3.95 4.232a2 2 0 010 2.73z",
    fill: "#060609"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fio-arrow-right-filter"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 7.5 0)",
    fill: "#fff",
    d: "M7.5 0H33v7H7.5z"
  }))));
}